











import { Vue, Component, Prop } from 'vue-property-decorator'

const MaterialIconAlias = 'material-icons' as const
type IconPack = typeof MaterialIconAlias | 'feather' | 'svg'

@Component
export default class Icon extends Vue {
  @Prop({ type: String, default: MaterialIconAlias }) readonly iconPack!: IconPack

  @Prop({ type: String }) readonly icon!: string

  @Prop({ type: String, default: '20px' }) readonly size!: string

  @Prop({ type: String, default: null }) color!: string | null

  /**
   * works with material icon*/
  @Prop() iconStyle!: 'outlined' | 'round' | 'sharp' | 'two-tone' | undefined

  get iconStyles(): any {
    return {
      'font-size': /(px)/.test(this.size) ? this.size : /(em)/.test(this.size) ? this.size : null,
      color: this.color,
    }
  }

  get iconName() {
    if (this.iconPack === MaterialIconAlias) {
      if (this.iconStyle !== undefined) {
        return `${ MaterialIconAlias }-${ this.iconStyle }`
      }

      return MaterialIconAlias
    }

    return this.icon
  }
}
